import { Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const Kicker = ({ children, className = "", tone = "red" }) => (
  <span
    className={`font-body text-xs font-semibold uppercase tracking-[0.35em] ${
      tone === "yellow" ? "text-brand-yellow" : "text-brand-red"
    } ${className}`}
  >
    {children}
  </span>
);

export const SectionHeader = ({ kicker, title, sub, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {kicker && <Reveal><Kicker>{kicker}</Kicker></Reveal>}
    <Reveal i={1}>
      <h2 className="mt-4 font-display text-4xl uppercase leading-[0.92] tracking-tight text-charcoal sm:text-5xl lg:text-6xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal i={2}>
        <p className="mt-5 font-body text-base leading-relaxed text-fog md:text-lg">{sub}</p>
      </Reveal>
    )}
  </div>
);

export const StarRating = ({ value = 5, className = "" }) => (
  <div className={`flex gap-0.5 ${className}`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${i < value ? "fill-brand-yellow text-brand-yellow" : "fill-sand text-sand"}`}
      />
    ))}
  </div>
);

export const Stat = ({ value, label }) => (
  <div>
    <div className="font-display text-5xl uppercase leading-none text-brand-red md:text-6xl">{value}</div>
    <div className="mt-2 font-body text-sm uppercase tracking-wide text-fog">{label}</div>
  </div>
);
